import { Link } from "react-router-dom";

/**
 * Creator Intelligence Tube — Brand Logo
 * "Creator Intelligence" in charcoal (#1F2937)
 * "Tube" in vibrant orange (#FF6B00)
 * Original play glyph subtly integrated behind "Tube".
 * Fully original artwork — does not reproduce the YouTube logo.
 */
export function BrandMark({ size = 36, className = "" }) {
  // Rounded-square with an off-center play triangle — inspired by video UIs but original
  return (
    <div
      className={`relative rounded-2xl flex items-center justify-center shadow-lg shadow-primary/25 ${className}`}
      style={{
        width: size,
        height: size,
        background: "linear-gradient(135deg, #FF6B00 0%, #FF8A3D 100%)",
      }}
      aria-hidden="true"
    >
      {/* Subtle inner glow */}
      <div className="absolute inset-0.5 rounded-[calc(1rem-2px)] bg-gradient-to-br from-white/25 to-transparent pointer-events-none" />
      {/* Custom play glyph (rounded triangle) */}
      <svg
        viewBox="0 0 24 24"
        width={size * 0.55}
        height={size * 0.55}
        className="relative drop-shadow-sm"
        fill="white"
      >
        <path
          d="M8.5 6.2c0-1.1 1.2-1.8 2.1-1.3l7.2 4.8c.9.6.9 1.8 0 2.4l-7.2 4.8c-.9.6-2.1-.2-2.1-1.3V6.2z"
          transform="translate(-1 1.5)"
        />
      </svg>
    </div>
  );
}

export function BrandWordmark({ compact = false }) {
  return (
    <div className="leading-tight">
      <div className={`font-extrabold tracking-tight ${compact ? "text-sm" : "text-base"}`}>
        <span className="text-[#1F2937] dark:text-white">Creator Intelligence</span>{" "}
        <span className="relative inline-block text-primary">
          Tube
          {/* Subtle play mark behind Tube - decorative */}
          <span
            aria-hidden="true"
            className="absolute -right-3 top-1/2 -translate-y-1/2 w-4 h-4 rounded-md bg-primary/10 pointer-events-none"
          />
        </span>
      </div>
      {!compact && (
        <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-0.5">
          AI-Powered YouTube Analytics Platform
        </div>
      )}
    </div>
  );
}

export default function BrandLogo({ compact = false, size = 36, to = "/", testId = "brand-logo" }) {
  return (
    <Link to={to} data-testid={testId} className="flex items-center gap-2.5 group shrink-0">
      <div className="group-hover:scale-105 transition-transform">
        <BrandMark size={size} />
      </div>
      <BrandWordmark compact={compact} />
    </Link>
  );
}
